import React, { useEffect, useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import useFacility from "../../../utils/hooks/useFacility";
import { GET_USER_TICKETS_URL } from "../../api/apiRoutes";
import { Ticket } from "../../models/Ticket";
import { format } from "date-fns";
import QRCode from "react-qr-code";

const AccountTickets: React.FC = () => {
  const { get } = useApiRequest();
  const facilityIds = useFacility();
  const [tickets, setTickets] = useState<Ticket[]>([]);

  const getTickets = async () => {
    const { result, isError } = await get(GET_USER_TICKETS_URL(facilityIds));
    if (!isError) {
      setTickets(result);
    }
  };

  useEffect(
    () => {
      getTickets();
    }, //eslint-disable-next-line
    []
  );

  return (
    <React.Fragment>
      <h3>Twoje bilety:</h3>
      {tickets.length === 0 ? (
        <div className={"docs-panel-empty"}>
          <h2>Czegoś tu brakuje?</h2>
          <p>Najwyższa pora to zmienić, zachęcamy do zakupu biletów.</p>
        </div>
      ) : (
        <React.Fragment>
          {tickets.map((ticket, index) => (
            <div key={index} className={"ticket-panel"}>
              <img src={"https://panel.eaktywni.pl/img/kinoTesty/gucci.jfif"} alt={"gucci"} />
              <h4>Gucci</h4>
              <div>
                <span>Obiekt:</span>
                <span>
                  {ticket.facilityName}, {ticket.facilityLocality}
                </span>
              </div>
              <div>
                <span>Data:</span>
                <span>{format(ticket.validfrom, "dd.MM.yyyy")}</span>
              </div>
              <div>
                <span>Czas:</span>
                <span>{format(ticket.validfrom, "HH:mm")}</span>
              </div>
              <div>
                <span>Rząd:</span>
                <span>{"1"}</span>
              </div>
              <div>
                <span>Miejsce:</span>
                <span>{"14"}</span>
              </div>
              <QRCode value={ticket.trhId} size={100} />
            </div>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default AccountTickets;
